document.addEventListener('DOMContentLoaded', function() {
  // 全てのテキスト要素を取得
  const elements = document.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, div, a, li');
  
  elements.forEach(function(element) {
    // テキストノードのみを処理(子要素を壊さないように)
    if (element.childNodes.length > 0) {
      element.childNodes.forEach(function(node) {
        if (node.nodeType === 3) { // テキストノードの場合
          const text = node.textContent;
          if (text.includes('{改行}')) {
            const newHTML = text.replace(/\{改行\}/g, '<br>');
            const span = document.createElement('span');
            span.innerHTML = newHTML;
            node.replaceWith(span);
          }
        }
      });
    }
  });
});
